import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Conversation, SdrConversation } from '../../../model/sdr-conversations/sdrs-conversations.model';
import { SdrConversationsService } from '../../../services/sdr-conversations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
    selector: 'app-extra-info',
    templateUrl: './extra-info.component.html',
    styleUrls: ['./extra-info.component.scss'],
    standalone: false
})
export class ExtraInfoComponent implements OnInit, OnDestroy {
  @Input() customer?: { id: number, name: string };
  selectedConversation: Conversation = null;
  sdrConversation: SdrConversation = null;
  private destroy$: Subject<boolean> = new Subject();
  constructor(
    private sdrConversationsService: SdrConversationsService,
  ) {}

  public ngOnInit(): void {
    this.sdrConversationsService.selectedConversation$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (selectedConversation: Conversation) => {
        if (selectedConversation) {
          this.selectedConversation = {
            ...selectedConversation,
            encryptedUrls: selectedConversation?.encryptedUrls?.map((url) => `https://linkedin.com${url}`),
          };
        }

        if (selectedConversation?.conversationId) {
          this.sdrConversation = this.sdrConversationsService.findSdrdByConversationId(
            selectedConversation.conversationId,
          );
        }
      },
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
